import { Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { TransferHistory$reflection, ContractType$reflection, Contract$reflection } from "../../Containers/Invoicee/Common.js";
import { union_type, record_type, option_type, class_type, string_type, list_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { LoadState$2, LoadState$2$reflection } from "../../Global.js";
import { createReducer, createAction } from "../Redux.js";

export class ContractState extends Record {
    constructor(Contracts, ContractTypes, TransferHistory) {
        super();
        this.Contracts = Contracts;
        this.ContractTypes = ContractTypes;
        this.TransferHistory = TransferHistory;
    }
}

export function ContractState$reflection() {
    return record_type("Redux.Reducers.Contract.ContractState", [], ContractState, () => [["Contracts", LoadState$2$reflection(list_type(Contract$reflection()), string_type)], ["ContractTypes", LoadState$2$reflection(class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, ContractType$reflection()]), string_type)], ["TransferHistory", LoadState$2$reflection(option_type(TransferHistory$reflection()), string_type)]]);
}

export class ContractAction extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["SetContracts", "SetContractTypes", "SetTransferHistory"];
    }
}

export function ContractAction$reflection() {
    return union_type("Redux.Reducers.Contract.ContractAction", [], ContractAction, () => [[["Item", LoadState$2$reflection(list_type(Contract$reflection()), string_type)]], [["Item", LoadState$2$reflection(class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, ContractType$reflection()]), string_type)]], [["Item", LoadState$2$reflection(option_type(TransferHistory$reflection()), string_type)]]]);
}

export function setContracts(payload) {
    return createAction("ContractReducer", new ContractAction(0, payload));
}

export function setContractTypes(payload) {
    return createAction("ContractReducer", new ContractAction(1, payload));
}

export function setTransferHistory(payload) {
    return createAction("ContractReducer", new ContractAction(2, payload));
}

export const initState = new ContractState(new LoadState$2(0), new LoadState$2(0), new LoadState$2(0));

function innerReducer(state, action) {
    switch (action.tag) {
        case 1: {
            return new ContractState(state.Contracts, action.fields[0], state.TransferHistory);
        }
        case 2: {
            return new ContractState(state.Contracts, state.ContractTypes, action.fields[0]);
        }
        default: {
            return new ContractState(action.fields[0], state.ContractTypes, state.TransferHistory);
        }
    }
}

export function reducer(stateOpt, action) {
    return createReducer("ContractReducer", initState, stateOpt, action, innerReducer);
}

